import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Cafe"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1.5 21H22.5V22.5H1.5V21ZM18.375 8.25H6C5.17192 8.25083 4.50083 8.92192 4.5 9.75V15.75C4.50248 17.82 6.17996 19.4975 8.25 19.5H14.25C16.32 19.4975 17.9975 17.82 18 15.75V15H18.375C20.239 15 21.75 13.489 21.75 11.625C21.75 9.76104 20.239 8.25 18.375 8.25ZM16.5 15.75C16.4988 16.9921 15.4921 17.9988 14.25 18H8.25C7.00787 17.9988 6.00124 16.9921 6 15.75V9.75H16.5V15.75ZM18.375 13.5H18V9.75H18.375C19.4105 9.75 20.25 10.5895 20.25 11.625C20.25 12.6605 19.4105 13.5 18.375 13.5ZM14.25 6.75H12.75V6.6405C12.7522 6.0718 12.4308 5.55135 11.9212 5.29875L9.90749 4.293C8.8888 3.7874 8.24604 2.74675 8.24999 1.6095V0.75H9.74999V1.6095C9.7481 2.1781 10.0695 2.69838 10.5787 2.95125L12.5917 3.957C13.6106 4.46253 14.2536 5.50313 14.25 6.6405V6.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Cafe.vue"]]);
